module.exports = __webpack_public_path__ + "img/circle-check-sharp-solid.54fe4271.svg";